jQuery(document).ready(function ($) {

    // Open first accordion in single product
    $('.woocommerceSingle__accordion-element:first-of-type').addClass('show');
    $('.woocommerceSingle__accordion-element:first-of-type').find('.woocommerceSingle__accordion-heading').addClass('open');
    $('.woocommerceSingle__accordion-element:first-of-type').find('.woocommerceSingle__accordion-content').toggle();

    $(".woocommerceSingle__accordion-heading").click(function() {
        var element = $(this).parent();
        var accordion = $('.woocommerceSingle__accordion');

        // Close already opened elements
        if ($(accordion).length > 0){
            $(accordion).find('.show').not(element).each(function(){
                $(this).removeClass('show');
                $(this).find('.woocommerceSingle__accordion-heading').removeClass('open');
                $(this).find('.woocommerceSingle__accordion-content').slideToggle();
            });
    
            // Check if element was already opened
            $(element).toggleClass('show');
            
            // Add open class to heading
            $(this).toggleClass('open');
    
            // Toggle element content
            $(element).find('.woocommerceSingle__accordion-content').slideToggle();
        }
    });
});